export default function AmbassadorFAQ() {
  const rows = [
    {
      q: 'How are referrals tracked?',
      a: 'Your referral code is attached to users who join through your link and is used for protocol fee attribution.',
    },
    {
      q: 'What counts as an eligible transaction?',
      a: 'Eligible protocol-fee transactions that generate on-platform fees are included in Ambassador rewards.',
    },
    {
      q: 'Do I earn if I am inactive?',
      a: 'Earnings can pause while inactive. They resume when eligibility requirements are met again.',
    },
    {
      q: 'What happens if my reputation drops?',
      a: 'Tier can downgrade and payouts can pause until your reputation returns above the required threshold.',
    },
    {
      q: 'How do tiers work?',
      a: 'Higher tiers unlock higher shares of protocol fees, with a total cap of 15% of protocol fee.',
    },
    {
      q: 'Can I lose Ambassador status?',
      a: 'Yes. Fraud, spam, abuse, or policy violations may pause or revoke Ambassador rewards.',
    },
    {
      q: 'How do payouts work?',
      a: 'Ambassador rewards are ledger-based and settle into your earnings balance based on platform policy.',
    },
  ]

  return (
    <section className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <h2 className="text-lg font-bold">FAQ + Rules</h2>
      <div className="mt-3 space-y-2">
        {rows.map((row) => (
          <details key={row.q} className="rounded-xl border border-white/10 bg-black/30 p-3">
            <summary className="cursor-pointer list-none font-semibold">{row.q}</summary>
            <div className="mt-2 text-sm text-white/70">{row.a}</div>
          </details>
        ))}
      </div>
    </section>
  )
}
